module.exports = __webpack_public_path__ + "static/media/rewards-and-recognitions-logo.61e823ff.svg";